// extracted by mini-css-extract-plugin
export var searchDropdown = "landingSearchBlock-module--searchDropdown--UWBjr";
export var searchDropdownContainer = "landingSearchBlock-module--searchDropdownContainer--O3kS9";
export var searchdropdown = "landingSearchBlock-module--searchdropdown--t4pft";